var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "voiceExam" } },
    [
      _c(
        "el-steps",
        {
          staticStyle: { margin: "20px 0" },
          attrs: {
            active: _vm.stepactive,
            "finish-status": "success",
            simple: ""
          }
        },
        [
          _c("el-step", {
            attrs: { title: "功能学习" },
            nativeOn: {
              click: function($event) {
                _vm.stepactive >= 2 && _vm.showStep(1)
              }
            }
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: { title: "测试须知" },
            nativeOn: {
              click: function($event) {
                _vm.stepactive >= 2 && _vm.showStep(2)
              }
            }
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: { title: "开始测试" },
            nativeOn: {
              click: function($event) {
                _vm.stepactive >= 3 && _vm.showStep(3)
              }
            }
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: { title: "测试合格" },
            nativeOn: {
              click: function($event) {
                _vm.stepactive >= 4 && _vm.showStep(4)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.clickFlag == 1
        ? _c(
            "div",
            { staticClass: "js-video" },
            [
              _c("p", { staticClass: "red" }, [
                _vm._v(
                  "温馨提示：语音客服必须掌握小助手的功能，请认真观看视频，学完所有功能，不要快进，否则不能正常进入下一步。"
                )
              ]),
              _vm._v(" "),
              _c(
                "el-tabs",
                {
                  attrs: { "tab-position": "left" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.tabCurrent,
                    callback: function($$v) {
                      _vm.tabCurrent = $$v
                    },
                    expression: "tabCurrent"
                  }
                },
                [
                  _c("el-tab-pane", { attrs: { name: "first" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-slot",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_c("p", { staticClass: "title" }, [_vm._v("打卡")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "video-box",
                        attrs: { id: "video-first" }
                      },
                      [
                        _c(
                          "video",
                          {
                            staticClass: "video",
                            attrs: {
                              id: "first",
                              src:
                                "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/1.%E6%89%93%E5%8D%A1.mp4",
                              controls: "controls"
                            }
                          },
                          [
                            _vm._v(
                              "\n              您的浏览器不支持 video 标签。\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-first" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("视频学习完毕")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "restart",
                                on: { click: _vm.restartVideo }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-refresh-left"
                                }),
                                _vm._v("重播")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-second")
                                  }
                                }
                              },
                              [_vm._v("继续下一步学习")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { name: "second" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-slot",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("领数据外呼")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "video-box",
                        attrs: { id: "video-second" }
                      },
                      [
                        _c(
                          "video",
                          {
                            staticClass: "video",
                            attrs: {
                              id: "second",
                              src:
                                "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/2.%E9%A2%86%E6%95%B0%E6%8D%AE%E5%A4%96%E5%91%BC.mp4",
                              controls: "controls"
                            }
                          },
                          [
                            _vm._v(
                              "\n              您的浏览器不支持 video 标签。\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-second" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("视频学习完毕")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "restart",
                                on: { click: _vm.restartVideo }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-refresh-left"
                                }),
                                _vm._v("重播")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-third")
                                  }
                                }
                              },
                              [_vm._v("继续下一步学习")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { name: "third" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-slot",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("修改客户资料")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "video-box",
                        attrs: { id: "video-third" }
                      },
                      [
                        _c(
                          "video",
                          {
                            staticClass: "video",
                            attrs: {
                              id: "third",
                              src:
                                "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/3.%E4%BF%AE%E6%94%B9%E5%AE%A2%E6%88%B7%E8%B5%84%E6%96%99.mp4",
                              controls: "controls"
                            }
                          },
                          [
                            _vm._v(
                              "\n              您的浏览器不支持 video 标签。\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-third" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("视频学习完毕")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "restart",
                                on: { click: _vm.restartVideo }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-refresh-left"
                                }),
                                _vm._v("重播")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-four")
                                  }
                                }
                              },
                              [_vm._v("继续下一步学习")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { name: "four" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-slot",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_c("p", { staticClass: "title" }, [_vm._v("下载录音")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "video-box", attrs: { id: "video-four" } },
                      [
                        _c(
                          "video",
                          {
                            staticClass: "video",
                            attrs: {
                              id: "four",
                              src:
                                "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/4.%E4%B8%8B%E8%BD%BD%E5%BD%95%E9%9F%B3.mp4",
                              controls: "controls"
                            }
                          },
                          [
                            _vm._v(
                              "\n              您的浏览器不支持 video 标签。\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("视频学习完毕")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "restart",
                                on: { click: _vm.restartVideo }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-refresh-left"
                                }),
                                _vm._v("重播")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-five")
                                  }
                                }
                              },
                              [_vm._v("继续下一步学习")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { name: "five" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-slot",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_c("p", { staticClass: "title" }, [_vm._v("呼入操作")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "video-box", attrs: { id: "video-five" } },
                      [
                        _c(
                          "video",
                          {
                            staticClass: "video",
                            attrs: {
                              id: "five",
                              src:
                                "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/5.%E5%91%BC%E5%85%A5%E6%93%8D%E4%BD%9C.mp4",
                              controls: "controls"
                            }
                          },
                          [
                            _vm._v(
                              "\n              您的浏览器不支持 video 标签。\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("视频学习完毕")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "restart",
                                on: { click: _vm.restartVideo }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-refresh-left"
                                }),
                                _vm._v("重播")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.studyNextLast }
                              },
                              [_vm._v("进入测试须知")]
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.clickFlag == 2
        ? _c(
            "div",
            { staticClass: "warp" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm.miaoone !== 0 && _vm.stepactive == 2
                ? _c(
                    "el-button",
                    { staticClass: "btn hui", attrs: { type: "primary" } },
                    [_vm._v("我已知晓(" + _vm._s(_vm.miaoone) + "s)")]
                  )
                : _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.goNext }
                    },
                    [_vm._v("我已知晓")]
                  )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.isShowStepOne ||
        _vm.isShowStepTwo ||
        _vm.isShowStepThird ||
        _vm.isShowStepFour) &&
      _vm.clickFlag === 3 &&
      _vm.stepactive === 3
        ? _c("div", { staticClass: "opertionbg" })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowStepOne && _vm.clickFlag === 3 && _vm.stepactive === 3
        ? _c("div", { staticClass: "opertiontip-box" }, [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tip-text" },
              [
                _c("p", [_vm._v("请认真阅读注意事项！")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.showStepTwo }
                  },
                  [_vm._v("下一步")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowStepTwo && _vm.clickFlag === 3 && _vm.stepactive === 3
        ? _c("div", { staticClass: "opertiontip-box tip-two" }, [
            _vm._m(3),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tip-text" },
              [
                _c("p", [_vm._v("这是一段优秀录音，请认真学习！")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.showStepThird }
                  },
                  [_vm._v("下一步")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowStepThird && _vm.clickFlag === 3 && _vm.stepactive === 3
        ? _c("div", { staticClass: "opertiontip-box tip-third" }, [
            _c(
              "div",
              { staticClass: "tip-text" },
              [
                _c("p", [_vm._v("以下是参考话术，测试时需要使用此话术")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.showStepFour }
                  },
                  [_vm._v("下一步")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _vm._m(6)
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clickFlag == 3
        ? _c("div", { staticClass: "opertion warp" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "test-outer-container" }, [
              _vm.isShowStepFour && _vm.clickFlag === 3 && _vm.stepactive === 3
                ? _c("div", { staticClass: "opertiontip-box tip-four" }, [
                    _c(
                      "div",
                      { staticClass: "tip-text" },
                      [
                        _c("p", [_vm._v("学习时间180秒后可以开始测试")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.closeStep }
                          },
                          [_vm._v("确定")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(8),
                    _vm._v(" "),
                    _c("div", { staticClass: "opertiontip" }, [
                      _c("div", { staticClass: "step-tip" }, [
                        _vm.status == "AlreadyTheoryBadge" ||
                        _vm.status == "NoTheoryBadge"
                          ? _c("div", { staticClass: "result" }, [
                              _c(
                                "p",
                                { staticClass: "tip" },
                                [
                                  _vm._v("温馨提示："),
                                  _c("font", { attrs: { color: "red" } }, [
                                    _c("b", [
                                      _vm._v(
                                        "每天只能进行一次测试，外呼时请参考话术内容。"
                                      )
                                    ])
                                  ]),
                                  _vm._v("准备好即可开始测试，请珍惜测试机会。")
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.status == "Failed"
                          ? _c("div", { staticClass: "result" }, [
                              _c("p", { staticClass: "failtext" }, [
                                _vm._v("很遗憾，测试未通过！")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "reason" }, [
                                _vm._v("未通过原因："),
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(_vm.result) }
                                })
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.status == "AlreadyTheoryBadge" ||
              _vm.status == "NoTheoryBadge"
                ? _c(
                    "div",
                    { staticClass: "result" },
                    [
                      _c(
                        "p",
                        { staticClass: "tip" },
                        [
                          _vm._v("温馨提示："),
                          _c("font", { attrs: { color: "red" } }, [
                            _c("b", [
                              _vm._v(
                                "每天只能进行一次测试，外呼时请参考话术内容。"
                              )
                            ])
                          ]),
                          _vm._v("准备好即可开始测试，请珍惜测试机会。")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.miaotwo !== 0 && _vm.stepactive === 3
                        ? _c(
                            "el-button",
                            {
                              staticClass: "btn hui",
                              attrs: { type: "primary" }
                            },
                            [_vm._v("开始测试(" + _vm._s(_vm.miaotwo) + "s)")]
                          )
                        : _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: {
                                type: "primary",
                                disabled: _vm.isDisable
                              },
                              on: { click: _vm.startExam }
                            },
                            [_vm._v("开始测试")]
                          )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.status == "Failed"
                ? _c("div", { staticClass: "result" }, [
                    _c("p", { staticClass: "failtext" }, [
                      _vm._v("很遗憾，测试未通过！")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "reason" }, [
                      _vm._v("未通过原因："),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.result) }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.retry == "true"
                      ? _c(
                          "p",
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: {
                                  type: "primary",
                                  disabled: _vm.isDisable
                                },
                                on: { click: _vm.replyBegin }
                              },
                              [_vm._v("重新测试")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.retry == "false"
                      ? _c("p", [_vm._v("请按照上面提示进行操作！")])
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.status == "Ongoing"
              ? _c("div", [
                  _vm._m(9),
                  _vm._v(" "),
                  _c(
                    "p",
                    { on: { click: _vm.getCurrentStep } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { type: "primary", icon: "el-icon-refresh" }
                        },
                        [_vm._v("点击刷新审核结果")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clickFlag >= 4
        ? _c("div", { staticClass: "opertion otheropertion" }, [
            _vm.status == "Passed"
              ? _c("div", { staticClass: "pass password" }, [
                  _c("p", [_vm._v("恭喜你！")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("你已经通过系统测试")]),
                  _vm._v(" "),
                  _vm.Finished !== "yes"
                    ? _c("p", [_vm._v("快去完成“技能提升”的学习与测试吧！")])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "button_box" }, [
                    _vm.registration == 1
                      ? _c("div", { staticClass: "btn-box button_box" }, [
                          _c(
                            "span",
                            {
                              staticClass: "button_again",
                              on: { click: _vm.relearn }
                            },
                            [_vm._v("点击重新学习")]
                          ),
                          _vm._v(" "),
                          _c("span", { on: { click: _vm.sign_up } }, [
                            _vm._v("去查看报名场次")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.registration == 0
                      ? _c("div", { staticClass: "btn-box button_box" }, [
                          _c(
                            "span",
                            {
                              staticClass: "button_again",
                              on: { click: _vm.relearn }
                            },
                            [_vm._v("点击重新学习")]
                          ),
                          _vm._v(" "),
                          _c("span", { on: { click: _vm.sign_up } }, [
                            _vm._v("去报名")
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "title" }, [
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot bigger" }),
        _vm._v(" "),
        _c("span", [_vm._v("测试目的")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot bigger" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "whitebg" }, [
        _c("p", [
          _c("span", { staticClass: "dot big" }),
          _vm._v("检测您是否掌握了小助手的使用方法")
        ]),
        _vm._v(" "),
        _c("p", [
          _c("span", { staticClass: "dot big" }),
          _vm._v("检测您是否符合语音客服的条件")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "whitebg flex" }, [
        _c("div", { staticClass: "left" }, [
          _c("p", [
            _c("span", { staticClass: "type" }, [_vm._v("设备要求")]),
            _vm._v(" "),
            _c("span", [_vm._v("必须要有耳麦")])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt" }, [
            _c("span", { staticClass: "type" }, [_vm._v("测试时间")]),
            _vm._v(" "),
            _c("span", [_vm._v("9:00-17:30")])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt" }, [
            _c("span", { staticClass: "type" }, [_vm._v("测试机会")]),
            _vm._v(" "),
            _c("span", [_vm._v("每人每天有一次测试机会")])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt" }, [
            _c("span", { staticClass: "type" }, [_vm._v("测试结果")]),
            _vm._v(" "),
            _c("span", [_vm._v("当天18点前会出测试结果")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c("p", [_c("span", { staticClass: "type" }, [_vm._v("合格标准")])]),
          _vm._v(" "),
          _c("p", [_vm._v("1、完成当天的测试外呼量（10通电话）")]),
          _vm._v(" "),
          _c("p", [_vm._v("2、普通话良好")]),
          _vm._v(" "),
          _c("p", [_vm._v("3、耳麦没有回音、杂音")]),
          _vm._v(" "),
          _c("p", [_vm._v("4、话术流畅、灵活性强")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot bigger" }),
        _vm._v(" "),
        _c("span", [_vm._v("操作说明")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot bigger" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "whitebg" }, [
        _c("p", { staticClass: "red" }, [
          _vm._v("温馨提示：请认真观看视频，不然你不知道接下来应该怎么做！")
        ]),
        _vm._v(" "),
        _c(
          "video",
          {
            staticClass: "video",
            attrs: {
              src:
                "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/6.%E7%B3%BB%E7%BB%9F%E6%B5%8B%E8%AF%95.mp4",
              controls: "controls"
            }
          },
          [_vm._v("\n            您的浏览器不支持 video 标签。\n          ")]
        )
      ]),
      _vm._v("test-guide\n        "),
      _c("div", { staticClass: "title" }, [
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot bigger" }),
        _vm._v(" "),
        _c("span", [_vm._v("温馨提示")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot bigger" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "whitebg" }, [
        _c("p", [_vm._v("系统测试时，请保持您的电话畅通；")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "如果您的耳麦有问题，我们平台的工作人员会电话联系您（为了您能顺利通过测试，请不要拒接，谢谢）；"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "电话联系不上您时，我们会在APP上的消息中私信您，或者发送系统消息通知您，请注意查看信息。"
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "blue" }, [
          _vm._v(
            "*ps：外呼过程中，有任何的问题，可以点击小助手上的“在线沟通”，在“今日系统测试咨询群”反馈。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "opertiontip" }, [
      _c("div", { staticClass: "step-tip" }, [
        _c("span", { staticClass: "red" }, [
          _vm._v(
            "*注意：外呼测试的时候，接听对象是机器人，必须要用这个话术，才能和机器人进行对话，否则测试不合格！（右侧有录音参考）"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip-quan" }, [
      _c("img", { attrs: { src: require("../../../static/tip-quan-up.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "opertiontip" }, [
      _c("div", { staticClass: "step-tip" }, [
        _c("audio", {
          attrs: {
            src:
              "http://res.study.itaojin.cn/2020-09/luyinanli.mp3?version=0821",
            controls: "controls"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip-quan" }, [
      _c("img", { attrs: { src: require("../../../static/tip-quan-up.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip-quan" }, [
      _c("img", {
        attrs: { src: require("../../../static/tip-quan-down.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "opertiontip" }, [
      _c("div", { staticClass: "step-tip" }, [
        _c("table", { staticClass: "huashu" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { width: "120" } }),
              _vm._v(" "),
              _c("th", { attrs: { width: "200" } }, [_vm._v("步骤")]),
              _vm._v(" "),
              _c("th", [_vm._v("客服参考话术")])
            ])
          ]),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("td", { staticClass: "blue" }, [_vm._v("开场白")]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [
                _vm._v("核对尾号，确认机主")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "您好！我是淘金平台的工作人员，请问您是手机尾号****的机主吗？"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue" }, [_vm._v("探寻需求")]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [_vm._v("询问任务意向")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "今天给您致电是想做一个简单的回访，我们平台有语音客服任务、在线客服任务、标注客服任务，请问您是想做哪种类型的任务呢？"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue", attrs: { rowspan: "2" } }, [
                _vm._v("推荐产品")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [
                _vm._v("普通话好引导做语音")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "我听您普通话不错的，您可以考虑下做语音的任务，语音任务时薪报酬要比在线多几倍呢。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [
                _vm._v("获得徽章就可领任务")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，您可以在手机APP上完成语音基础培训，获得语音上岗徽章就可以申请语音的任务。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue", attrs: { rowspan: "2" } }, [
                _vm._v("异议处理")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [_vm._v("对方想做语音")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，请问您之前是有做过语音客服相关的工作吗？您可以在手机APP上完成语音基础培训，获得语音徽章就可以申请语音的任务。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("对方不想做语音")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，是您那边环境不适合做语音吗？那您可以在APP上完成在线基础培训，获得相关的在线徽章就可以申请在线的任务。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue" }, [_vm._v("结束语")]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "请尽快去APP上学习，我就不打扰您了，感谢您的接听，祝您生活愉快，再见！"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue", attrs: { rowspan: "11" } }, [
                _vm._v("其"),
                _c("br"),
                _vm._v("他"),
                _c("br"),
                _vm._v("常"),
                _c("br"),
                _vm._v("见"),
                _c("br"),
                _vm._v("问"),
                _c("br"),
                _vm._v("题")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [_vm._v("有工作，没时间")]),
              _vm._v(" "),
              _c("td", [_vm._v("好的，您以后有需要了欢迎您随时回来。")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [
                _vm._v("有工作但晚上有时间")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "您这种情况呢，我这边是建议您可以尝试做在线客服，在线任务的时间安排相对来说更自由一些。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("询问工资怎么计算")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "报酬是根据任务而定的，不同的任务，报酬也不同；常见的形式是时薪。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("培训收费吗")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "您放心，我们平台承诺大家在整个过程中都是完全免费的，不收取任何一分钱的费用。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("什么是在线客服？")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "在线客服主要是通过文字和顾客交流，跟淘宝上的客服一样的。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("什么是语音客服？")]),
              _vm._v(" "),
              _c("td", [
                _vm._v("语音客服主要是通过电话和顾客交流，就是电话销售。")
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("学习课程中有问题")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "这个情况的话，您可以在APP上反馈给班主任，班主任那边可以帮您解决。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("已经上岗")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，如果您执行任务中有任务问题，都可以直接反馈给主管，那我就不打扰您了，祝您生活愉快，再见！"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("是我家人注册的")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "那您知道您家人是想在我们平台做语音客服还是在线客服吗？目前是否已经上岗了呢？"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("做不好会有扣罚吗")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "这个也是视任务而定的，等申请任务之后，任务老师也会给您们提前说明扣罚的。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [
                _vm._v("我随便下载的，我不清楚你们是做什么的")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "我简单的给您介绍下我们平台，我们淘金是2015年成立，是客服外包平台，客服是在家执行任务，获得报酬，而且我们的任务大多是长期的，在家就可以在平台上获得稳定的收入，我们执行任务的时间也比较灵活，您可以用您平时的空闲时间来平台做任务。"
                )
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "title" }, [
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot bigger" }),
        _vm._v(" "),
        _c("span", [_vm._v("话术参考")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot bigger" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "Addmodifications" }, [
        _c("div", { staticClass: "audio-box" }, [
          _c("div", [
            _c("div", { staticClass: "red text-font" }, [
              _vm._v(
                "*注意：外呼测试的时候，接听对象是机器人，必须要用这个话术，才能和机器人进行对话，否则测试不合格！（右侧有录音参考）"
              )
            ])
          ]),
          _vm._v(" "),
          _c("audio", {
            attrs: {
              src:
                "http://res.study.itaojin.cn/2020-09/luyinanli.mp3?version=0821",
              controls: "controls"
            }
          })
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "huashu" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { width: "120" } }),
              _vm._v(" "),
              _c("th", { attrs: { width: "200" } }, [_vm._v("步骤")]),
              _vm._v(" "),
              _c("th", [_vm._v("客服参考话术")])
            ])
          ]),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("td", { staticClass: "blue" }, [_vm._v("开场白")]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [
                _vm._v("核对尾号，确认机主")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "您好！我是淘金平台的工作人员，请问您是手机尾号****的机主吗？"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue" }, [_vm._v("探寻需求")]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [_vm._v("询问任务意向")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "今天给您致电是想做一个简单的回访，我们平台有语音客服任务、在线客服任务、标注客服任务，请问您是想做哪种类型的任务呢？"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue", attrs: { rowspan: "2" } }, [
                _vm._v("推荐产品")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [
                _vm._v("普通话好引导做语音")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "我听您普通话不错的，您可以考虑下做语音的任务，语音任务时薪报酬要比在线多几倍呢。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [
                _vm._v("获得徽章就可领任务")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，您可以在手机APP上完成语音基础培训，获得语音上岗徽章就可以申请语音的任务。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue", attrs: { rowspan: "2" } }, [
                _vm._v("异议处理")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [_vm._v("对方想做语音")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，请问您之前是有做过语音客服相关的工作吗？您可以在手机APP上完成语音基础培训，获得语音徽章就可以申请语音的任务。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("对方不想做语音")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，是您那边环境不适合做语音吗？那您可以在APP上完成在线基础培训，获得相关的在线徽章就可以申请在线的任务。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue" }, [_vm._v("结束语")]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "请尽快去APP上学习，我就不打扰您了，感谢您的接听，祝您生活愉快，再见！"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue", attrs: { rowspan: "11" } }, [
                _vm._v("其"),
                _c("br"),
                _vm._v("他"),
                _c("br"),
                _vm._v("常"),
                _c("br"),
                _vm._v("见"),
                _c("br"),
                _vm._v("问"),
                _c("br"),
                _vm._v("题")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [_vm._v("有工作，没时间")]),
              _vm._v(" "),
              _c("td", [_vm._v("好的，您以后有需要了欢迎您随时回来。")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [
                _vm._v("有工作但晚上有时间")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "您这种情况呢，我这边是建议您可以尝试做在线客服，在线任务的时间安排相对来说更自由一些。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("询问工资怎么计算")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "报酬是根据任务而定的，不同的任务，报酬也不同；常见的形式是时薪。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("培训收费吗")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "您放心，我们平台承诺大家在整个过程中都是完全免费的，不收取任何一分钱的费用。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("什么是在线客服？")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "在线客服主要是通过文字和顾客交流，跟淘宝上的客服一样的。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("什么是语音客服？")]),
              _vm._v(" "),
              _c("td", [
                _vm._v("语音客服主要是通过电话和顾客交流，就是电话销售。")
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("学习课程中有问题")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "这个情况的话，您可以在APP上反馈给班主任，班主任那边可以帮您解决。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("已经上岗")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，如果您执行任务中有任务问题，都可以直接反馈给主管，那我就不打扰您了，祝您生活愉快，再见！"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("是我家人注册的")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "那您知道您家人是想在我们平台做语音客服还是在线客服吗？目前是否已经上岗了呢？"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("做不好会有扣罚吗")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "这个也是视任务而定的，等申请任务之后，任务老师也会给您们提前说明扣罚的。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [
                _vm._v("我随便下载的，我不清楚你们是做什么的")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "我简单的给您介绍下我们平台，我们淘金是2015年成立，是客服外包平台，客服是在家执行任务，获得报酬，而且我们的任务大多是长期的，在家就可以在平台上获得稳定的收入，我们执行任务的时间也比较灵活，您可以用您平时的空闲时间来平台做任务。"
                )
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip-quan positionimgbox" }, [
      _c("img", {
        staticClass: "tip-quan_positionimg",
        attrs: { src: require("../../../static/tip-quan-down.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "on" }, [
      _c("img", {
        attrs: {
          src:
            "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWeb/web/%E4%BB%BB%E5%8A%A1%E6%89%93%E5%8D%A12.png",
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe166578", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe166578","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/voice.vue
// module id = 1544
// module chunks = 0